module.exports = __webpack_public_path__ + "img/img.de384bfd.png";